import { StyleSheet } from 'react-native';
import colors from '@/config/colors';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  heading: {
    fontSize: theme.fontSizes.base,
    fontWeight: '600',
    fontFamily: 'InterSemiBold',
    color: colors.newUI.therapist.textBlue100,
    marginBottom: theme.spacings.sm,
  },
  description: {
    fontSize: theme.fontSizes.sm,
    fontWeight: '400',
    color: colors.newUI.therapist.textBlue100,
    marginBottom: theme.spacings.sm,
  },
  content: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginTop: theme.spacings.sm,
  },
  selectedAvatarWrapper: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  selectedAvatar: {
    width: 120,
    height: 120,
    borderRadius: 100,
  },
  picker: {
    flexGrow: 1,
    flexBasis: 240,
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 12,
    maxWidth: '70%',
  },
  avatar: {
    width: 62,
    height: 62,
    borderRadius: 100,
  },
  avatarSelected: {
    opacity: 1,
    borderWidth: 3,
    borderColor: colors.newUI.therapist.blue50,
  },
  avatarUnselected: {
    opacity: 0.6,
  },
});
